import React, { useState } from 'react';
import { Box, Typography, Divider, Grid, Button, Drawer } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { formatAddress } from '../../../../lib/helpers/helpers';
import EditAddressPopUp from '../subComponents/EditAddressPopUp';

const MiniAddressCard = ({ address, firstName, lastName, displayOnly = false }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  if (!address) {
    return null;
  }

  return (
    <Box
      id="address"
      sx={{
        display: 'flex',
        padding: '24px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        width: '100%',
        border:
          address.is_default === 1
            ? '3px solid var(--Tangelo-Matcha-matcha9, #00AD8C)'
            : '2px solid var(--color6, #D6D2E7)',
        background: address.is_default === 1 ? 'var(--Tangelo-Matcha-matcha1, #F9FEFC)' : '#FFF',
        mb: 2,
      }}
    >
      <Box
        id="address-info-container"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 'var(--3-5, 16px)',
          alignSelf: 'stretch',
        }}
      >
        <Box
          id="address-info"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            alignSelf: 'stretch',
          }}
        >
          <Box
            id="info"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '16px',
              alignSelf: 'stretch',
            }}
          >
            {firstName && lastName && (
              <Box
                id="name"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '13px',
                  alignSelf: 'stretch',
                }}
              >
                <Typography
                  sx={{
                    flex: '1 0 0',
                    color: 'var(--color12, #1C124D)',
                    leadingTrim: 'both',
                    textEdge: 'cap',
                    fontSize: '18px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: 'normal',
                    display: !firstName && !lastName ? 'none' : 'block',
                  }}
                >
                  {`${firstName || ''} ${lastName || ''}`}
                </Typography>
              </Box>
            )}
            <Typography
              sx={{
                alignSelf: 'stretch',
                color: 'var(--color12, #1C124D)',
                leadingTrim: 'both',
                textEdge: 'cap',
                fontSize: '18px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: 'normal',
              }}
            >
              {formatAddress(address)}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        id="address-box-buttons"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '16px',
          alignSelf: 'stretch',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center' }}>
          {address.is_default === 1 && (
            <Button
              id="default-address-button"
              sx={{
                display: 'flex',
                width: '100%',
                height: 'var(--3, 36px)',
                padding: 'var(--0, 0px) var(--3, 13px)',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 'var(--3, 13px)',
                borderRadius: 'var(--3, 7px)',
                border: 'var(--1, 2px) solid var(--Tangelo-Matcha-matcha6, #A2E2D4)',
                background: 'var(--Tangelo-Matcha-matcha6, #A2E2D4)',
              }}
              onClick={handleDrawerClose}
            >
              <CheckIcon
                sx={{
                  width: '20px',
                  height: '20px',
                }}
              />
              <Typography
                sx={{
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: 700,
                }}
              >
                Default Address
              </Typography>
            </Button>
          )}
          {/* {!displayOnly && (
            <Button
              id="edit-address-button"
              sx={{
                display: 'flex',
                width: '100%',
                height: 'var(--3, 36px)',
                padding: 'var(--0, 0px) var(--3, 13px)',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 'var(--3, 13px)',
                borderRadius: 'var(--3, 7px)',
                border: 'var(--1, 2px) solid var(--color12, #1C124D)',
                background: 'var(--color1, #FDFDFD)',
              }}
              onClick={handleDrawerOpen}
            >
              <Typography
                sx={{
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: 700,
                }}
              >
                Edit Address
              </Typography>
            </Button>
          )} */}
        </div>
      </Box>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleDrawerClose}
      >
        <EditAddressPopUp
          address={address}
          onClose={handleDrawerClose}
        />
      </Drawer>
    </Box>
  );
};

export default MiniAddressCard;
